import { Input } from 'antd'
import styled from '@emotion/styled'

const { TextArea } = Input

export default styled(TextArea)`
  font-size: 9px;
  margin-bottom: 20px;
`
